import axios from 'axios';

const Api = () => {
  const getProductsFetch = (): Promise<unknown> => axios.get(`${process.env.REACT_APP_BOOKING_BASE_URL}/products`);

  return { getProductsFetch };
};

export default Api;
